import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import {
  addToast
} from "../../../../actions/index";
import IconTombstone from './svg/IconTombstone';

function ColumnTombstoned({ width, style }) {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(addToast({ content: <span>This track is no longer available.</span>, typeClass: 'warning', iconStyle: { padding: 16, marginRight: 16  } }));
  }
  return (
    <div className='flexRow' style={{ width, gap: 5, textAlign: `-webkit-center`, cursor: 'pointer', zIndex: 50, ...style}}>
      <div className={'column-extra-action'} onClick={onClick}>
        <IconTombstone />
      </div>
    </div>
  )
}

ColumnTombstoned.propTypes = {
  width: PropTypes.number.isRequired,
  onClickCart: PropTypes.func,
  isInCart: PropTypes.bool,
  onClickPlaylist: PropTypes.func,
  style: PropTypes.object,
}

export default ColumnTombstoned;
